import { baseSeriesMark } from "../base/constant";

export const barSeriesMark = Object.assign(Object.assign({}, baseSeriesMark), {
    bar: {
        name: "bar",
        type: "rect"
    },
    barBackground: {
        name: "barBackground",
        type: "rect"
    }
});
//# sourceMappingURL=constant.js.map
